import React, { useState } from "react";
import { Helmet } from "react-helmet-async";


import {
  FaStar,
  FaClock,
  FaLaptop,
  FaUserCheck,
  FaBookOpen,
  FaHandsHelping,
  FaUniversity,
  FaGraduationCap,
  FaBook,
  FaLayerGroup,
  FaChartLine,
  FaHandshake,
  FaUsers,
  FaPlus,
  FaMinus,
  FaSnowflake,
  FaUser,
  FaDollarSign,
  FaBuilding,
  FaTruck,
  FaPhoneAlt,
  FaBullhorn,
  FaChartPie,
  FaUserTie,
  FaCogs,
  FaTasks,
  FaLightbulb,
  FaTruckLoading,
} from "react-icons/fa";

import "./McaCourse.css";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Accordion,
  Form,
} from "react-bootstrap";

import Slider from "react-slick";
import Admission from "../../components/Admission";
import Partner from "../../components/Partner";

export default function BbaCourse() {
  const careers = [
    {
      icon: <FaChartLine size={40} color="#2196F3" />, // Blue
      title: "Business Analyst",
    },
    {
      icon: <FaBullhorn size={40} color="#FF5722" />, // Deep Orange
      title: "Marketing Manager",
    },
    {
      icon: <FaChartPie size={40} color="#9C27B0" />, // Purple
      title: "Financial Analyst",
    },
    {
      icon: <FaUserTie size={40} color="#4CAF50" />, // Green
      title: "Human Resource Manager",
    },
    {
      icon: <FaCogs size={40} color="#607D8B" />, // Blue Grey
      title: "Operations Manager",
    },
    {
      icon: <FaTasks size={40} color="#E91E63" />, // Pink
      title: "Project Manager",
    },
    {
      icon: <FaLightbulb size={40} color="#FFC107" />, // Amber
      title: "Entrepreneur",
    },
    {
      icon: <FaTruckLoading size={40} color="#795548" />, // Brown
      title: "Supply Chain Manager",
    },
  ];

  const universities = [
    {
      name: "Subharti University",
      logo: "/images/subharti.png",
    },
    {
      name: "IGNOU",
      logo: "/images/ignou.png",
    },
    {
      name: "Andhra University",
      logo: "/images/andhra.png",
    },
    {
      name: "Amity University",
      logo: "/images/amity.png",
    },
    {
      name: "Lovely Professional University (LPU)",
      logo: "/images/lpu.png",
    },
    {
      name: "Sikkim Manipal University",
      logo: "/images/smu.png",
    },
    {
      name: "Chandigarh University",
      logo: "/images/chandigarh.png",
    },
    {
      name: "Jain University",
      logo: "/images/jain.png",
    },
    {
      name: "Annamalai University",
      logo: "/images/annamalai.png",
    },
    {
      name: "Delhi University (School of Open Learning)",
      logo: "/images/du.png",
    },
    {
      name: "Madras University",
      logo: "/images/madras.png",
    },
  ];

  const highlights = [
    {
      icon: "⏰",
      title: "Course Duration",
      description:
        "2 years (4 semesters) — designed for efficient learning while balancing work or other commitments.",
    },
    {
      icon: "📚",
      title: "Learning Mode",
      description:
        "Distance / Online — study from anywhere with access to online classes, study material, and recorded lectures.",
    },
    {
      icon: "🔍",
      title: "Eligibility",
      description:
        "A bachelor's degree (preferably BCA, B.Sc CS/IT) with Mathematics in 10+2 or graduation.",
    },
    {
      icon: "🏛️",
      title: "University Recognition",
      description:
        "Courses offered are from UGC and AICTE-approved universities, ensuring your degree is valid and recognized.",
    },
    {
      icon: "📖",
      title: "Curriculum",
      description:
        "Covers core programming, software engineering, DBMS, networking, cloud computing, and more.",
    },
    {
      icon: "🎧",
      title: "Support & Flexibility",
      description:
        "Study on your schedule with weekend sessions, recorded classes, student support, and online doubt-solving.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const steps = [
    {
      num: "1",
      title: "Fill the Application Form",
      text: "Establishing goals & blueprints for the new website",
      icon: "🔍",
    },
    {
      num: "2",
      title: "Document Verification",
      text: "Defining information architecture & content plan",
      icon: "📝",
    },
    {
      num: "3",
      title: "Confirm Admission & Pay Fees",
      text: "Designing the form & function of the website",
      icon: "🎨",
    },
  ];

  const data = [
    { icon: <FaChartLine />, number: "100%", label: "Success Rate" },
    { icon: <FaHandshake />, number: "35+", label: "Years Of Service" },
    { icon: <FaUsers />, number: "8k+", label: "Students" },
    { icon: <FaBook />, number: "10+", label: "Courses" },
  ];

  const plans = [
    {
      id: "01",
      color: "#00c6ff",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "02",
      color: "#2ecc71",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "03",
      color: "#f1c40f",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "04",
      color: "#e67e22",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "05",
      color: "#9b59b6",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "06",
      color: "#2980b9",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
  ];

  const blogs = [
    {
      title: "Writing Class",
      image: "https://via.placeholder.com/400x250?text=Writing+Class",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Crafts Activities",
      image: "https://via.placeholder.com/400x250?text=Crafts+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Math Activities",
      image: "https://via.placeholder.com/400x250?text=Math+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
  ];

  const faqData = [
    {
      question: "What is a Distance BBA program?",
      answer:
        "A Distance BBA is an undergraduate business administration degree delivered online or through correspondence, focusing on management, finance, marketing, and entrepreneurship without the need for regular campus attendance.",
    },
    {
      question: "Is a Distance BBA recognized and valid for jobs?",
      answer:
        "Yes. A Distance BBA from a UGC or AICTE-approved university is fully recognized for private and government jobs and is accepted for higher studies such as MBA or other postgraduate programs.",
    },
    {
      question: "What are the eligibility criteria for BBA distance education?",
      answer:
        "Applicants generally need to have completed 10+2 or an equivalent qualification from a recognized board. Some universities may have minimum percentage requirements.",
    },
    {
      question: "How long does it take to complete a Distance BBA?",
      answer:
        "Most Distance BBA programs take 3 years to complete, divided into 6 semesters. Some universities offer flexible schedules or the option to extend the duration if needed.",
    },
    {
      question: "Can I work while pursuing a Distance BBA?",
      answer:
        "Yes. Distance BBA programs are designed for working professionals and students who need flexibility, allowing you to learn online and access study materials anytime.",
    },
    {
      question: "What career opportunities are available after a Distance BBA?",
      answer:
        "Graduates can start careers in management, marketing, finance, HR, operations, or pursue higher studies like MBA to enhance career prospects.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const features = [
    {
      icon: <FaSnowflake />,
      title: "Study While You Work",
      details:
        "You don’t have to leave your job to pursue higher education. The flexible format allows you to manage both work and studies efficiently.",
    },
    {
      icon: <FaUser />,
      title: "Access Anytime, Anywhere",
      details:
        "Study from any location at your convenience. All course materials, video lectures, and assignments are accessible online—no need to attend physical classes.",
    },
    {
      icon: <FaDollarSign />,
      title: "Lower Cost, Same Degree",
      details:
        "Distance education is typically more affordable than traditional on-campus programs. Yet, the degree you earn is the same and equally valid.",
    },
    {
      icon: <FaBuilding />,
      title: "UGC/AICTE Approved Programs",
      details:
        "Your MCA degree comes from recognized institutions, ensuring credibility for jobs, promotions, or further studies.",
    },
    {
      icon: <FaTruck />,
      title: "Career-Aligned Curriculum",
      details:
        "The course content is tailored to match industry requirements with subjects like programming, software development, cloud computing, and AI.",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Self-Paced Learning with Expert Support",
      details:
        "You can learn at your own speed and still receive academic guidance, doubt-solving sessions, and mentorship when needed.",
    },
  ];

  const highlightsData = [
    {
      icon: <FaClock size={36} className="text-primary mb-3" />,
      title: "Course Duration",
      description:
        "The MCA program spans 2 years (4 semesters), designed for efficient learning while balancing work or personal commitments, providing a flexible path to earn a UGC-approved MCA distance education degree.",
    },
    {
      icon: <FaLaptop size={36} className="text-success mb-3" />,
      title: "Learning Mode",
      description:
        "Study through online MCA courses in Bangalore at your convenience. Access recorded lectures, digital study materials, and interactive learning anytime, making MCA distance education in Bangalore highly flexible for all students.",
    },
    {
      icon: <FaUserCheck size={36} className="text-warning mb-3" />,
      title: "Eligibility",
      description:
        "Applicants should have a bachelor’s degree (BCA, B.Sc CS/IT) with Mathematics in 10+2 or graduation. Eligibility ensures you can enroll in distance MCA colleges in Bangalore without hurdles.",
    },
    {
      icon: <FaUniversity size={36} className="text-info mb-3" />,
      title: "University Recognition",
      description:
        "Programs are UGC approved MCA online, recognized nationally for jobs, promotions, and higher studies, offered by the best online MCA colleges in Bangalore.",
    },
    {
      icon: <FaBookOpen size={36} className="text-danger mb-3" />,
      title: "Curriculum",
      description:
        "Covers programming, DBMS, software engineering, networking, cloud computing, AI, and cybersecurity to prepare students for careers in IT through best MCA distance learning colleges in Bangalore.",
    },
    {
      icon: <FaHandsHelping size={36} className="text-secondary mb-3" />,
      title: "Support & Flexibility",
      description:
        "Learn at your own pace with weekend sessions, online assessments, recorded lectures, and dedicated guidance from faculty, ensuring smooth learning through MCA correspondence courses in Bangalore.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Best Online BBA Colleges | Distance BBA Education Bangalore
        </title>
        <meta
          name="description"
          content="Explore BBA distance education in Bangalore. Join UGC-approved BBA correspondence courses, online BBA courses & top distance learning colleges."
        />
      </Helmet>
      <div className="mca-course-page">
        {/* ===== MCA Course Header ===== */}
        <section className="mca-course-header py-5 text-white">
          <Container>
            <Row className="align-items-center">
              {/* MCA Course Info */}
              <Col md={7} className="mca-course-header-content">
                <span className="mca-course-badge badge bg-warning text-dark mb-3">
                  Live Classes
                </span>
                <h1 className="mca-course-title fw-bold mb-3">
                  BBA Distance Education – Your Gateway to a Career in Business
                  Management{" "}
                </h1>
                <p className="mca-course-subtitle lead mb-3">
                  This MCA program is designed to build a strong foundation in
                  computer applications, programming, software development, and
                  IT management. You’ll gain advanced skills required for
                  careers in the tech industry.
                </p>
                <Button
                  variant="warning"
                  size="lg"
                  className="mca-course-enroll-btn fw-bold"
                >
                  Get admitted to the batch
                </Button>

                {/* MCA Course Rating */}
                <div className="mca-course-rating mt-3 d-flex align-items-center">
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <span className="ms-2">(4.8)</span>
                </div>
              </Col>

              {/* MCA Course Thumbnail */}
              <Col md={5} className="mca-course-header-thumbnail text-center">
                <img
                  src="/images/260744-removebg-preview.png"
                  alt="MCA Course Preview"
                  style={{ height: "400px", marginTop: "40px" }}
                />
              </Col>
            </Row>
          </Container>
        </section>

        {/* ===== MCA Course Content Section ===== */}

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              BBA Distance Education – Advance Your Career in Business &
              Management
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              The Bachelor of Business Administration (BBA) is a three-year
              undergraduate degree program designed for individuals who want to
              build or advance their careers in business, management, and
              entrepreneurship. Through distance education, students can earn a
              recognized BBA degree from UGC-approved universities without the
              need to attend regular on-campus classes. This flexible mode of
              learning is ideal for working professionals, recent school
              graduates, and those looking to gain foundational knowledge in
              business while managing other commitments. A distance BBA program
              covers essential subjects such as Business Management, Marketing,
              Financial Accounting, Human Resource Management, Economics, and
              Business Communication. The curriculum is designed to match
              current industry needs and helps students develop analytical
              thinking, leadership qualities, and decision-making skills
              required for roles such as business executive, marketing
              associate, HR officer, or operations manager. As businesses across
              sectors grow and evolve, BBA graduates are increasingly sought
              after for a wide range of administrative and strategic roles. One
              of the key advantages of pursuing a BBA through distance education
              is the flexibility it offers. Students can study at their
              convenience, access digital learning materials, appear for online
              assessments, and communicate with faculty through virtual
              platforms. The program is more affordable than traditional
              on-campus BBA degrees, yet it offers the same academic value and
              recognition. Choosing a BBA distance course from a reputed
              university ensures that your degree is valid for government jobs,
              private sector employment, or further studies like an MBA. Whether
              you aim to climb the corporate ladder, start your own business, or
              pursue higher education, a BBA degree provides the essential
              business knowledge and practical skills to help you succeed.
            </p>
          </Container>
        </section>

        <section
          style={{ background: "linear-gradient(to right, #f9fafb, #eef2ff)" }}
          className="py-5"
        >
          <Container>
            {/* Heading */}
            <div className="text-center mb-5">
              <h2 className="fw-bold text-dark display-6">
                Key Highlights of MCA Distance Education
              </h2>
              <p className="text-muted fs-5 mt-3 px-md-5">
                Making quality education accessible, flexible, and
                career-focused for learners across India.
              </p>
            </div>

            {/* Highlights Grid */}
            <Row className="g-4">
              {highlightsData.map((highlight, index) => (
                <Col md={6} key={index}>
                  <Card className="h-100 shadow border-0 text-center">
                    <Card.Body>
                      {highlight.icon}
                      <h5 className="fw-bold">{highlight.title}</h5>
                      <p className="text-muted">{highlight.description}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              BBA Distance Education – Advance Your Career in Business &
              Management
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              The Bachelor of Business Administration (BBA) distance education
              program is a 3-year undergraduate degree designed for individuals
              who want to build or advance their careers in business,
              management, and entrepreneurship. Through UGC-approved BBA
              distance education in Bangalore, students can earn a recognized
              degree without attending regular on-campus classes. This flexible
              learning mode is ideal for working professionals, recent
              graduates, and those seeking foundational business knowledge while
              managing other commitments. The distance BBA program in Bangalore
              covers key subjects like Business Management, Marketing, Financial
              Accounting, Human Resource Management, Economics, and Business
              Communication. The curriculum aligns with industry requirements
              and develops analytical thinking, leadership, and decision-making
              skills for roles such as business executive, marketing associate,
              HR officer, or operations manager. Flexibility is a major
              advantage of pursuing a BBA correspondence course in Bangalore.
              Students can study at their convenience, access online learning
              materials, attend virtual lectures, and appear for assessments
              remotely. The program is more affordable than regular on-campus
              courses while offering the same degree value and recognition.
              Enrolling in a distance BBA course from reputed universities
              ensures your degree is valid for government jobs, private sector
              employment, or higher education like MBA programs. Whether aiming
              to climb the corporate ladder, start a business, or pursue further
              studies, a BBA distance education program equips you with
              essential business knowledge and practical skills for success.
            </p>
          </Container>
        </section>

        <section className="why-section">
          <div className="why-head">
            <h1>Why Choose BBA via Distance Education?</h1>
          </div>
          <div className="why-container">
            {/* Left image */}
            <div className="why-image">
              <img src="/images/whychoose.jpg" alt="Why Choose Bangalore Distance Education for Your BBA Distance Education" />
            </div>

            {/* Right content */}
            <div className="why-content">
              <p className="section-text">
                Distance BBA programs are becoming increasingly popular among
                students and working professionals who want to gain business
                knowledge and management skills without disrupting their current
                schedules. Here’s why choosing a BBA through distance education
                is a smart move:
              </p>

              <div className="features-grid">
                {features.map((item, idx) => (
                  <div key={idx} className="feature-card">
                    <div className="feature-icon">{item.icon}</div>
                    <div>
                      <h3 className="feature-title">{item.title}</h3>
                      <p className="feature-text">{item.details}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Admission Process */}

        <Admission></Admission>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h1 className="text-center mb-5">Career Opportunities After BBA</h1>
            <p
              className="text-center mb-5"
              style={{ color: "#666", fontSize: "16px" }}
            >
              Earning an MCA through distance education opens up diverse career
              opportunities in the growing tech industry. With advanced
              knowledge in programming, software systems, and IT management, MCA
              graduates are highly sought after in both private and public
              sectors.
            </p>

            {/* Career Grid */}
            <Row className="text-center">
              {careers.map((career, index) => (
                <Col key={index} xs={12} sm={6} md={3} className="mb-4">
                  <div style={{ fontSize: "48px" }}>{career.icon}</div>
                  <h6 className="fw-bold mt-3">{career.title}</h6>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <Partner></Partner>

        {/* Register Now */}

        <div className="event-wrapper">
          {/* Curved shape */}
          <div className="curve"></div>

          {/* Left section */}
          <div className="left-section">
            <br />
            <h2>WE APPRECIATE ALL YOU DO</h2>
            <h3>Take the Next Step with Our Distance BBA Program</h3>
            <p>
              Ready to begin your journey in the world of business and
              management? Our Distance BBA program is designed to equip you with
              the foundational knowledge and practical skills needed to thrive
              in today’s competitive corporate environment. Whether you aim to
              work in marketing, finance, HR, or operations, this flexible
              program helps you learn at your own pace—without putting your
              current commitments on hold. With a UGC-approved curriculum,
              expert faculty support, and easy access to online study materials,
              the Distance BBA program is a smart choice for both students and
              working professionals. Take the next step toward a successful
              career in business—enroll today and unlock your potential.
            </p>
          </div>

          {/* Right section */}
          <div className="right-section">
            <form className="form-card">
              <h2>Registration</h2>
              <hr className="divider" />

              <input type="text" placeholder="Full Name*" />
              <input type="email" placeholder="Email*" />
              <input type="number" name="" id="" placeholder="Phone" />

              <button type="submit" className="register-btn">
                Register
              </button>

              <p className="footer-note">Your perfect events registrations</p>
            </form>
          </div>
        </div>

        {/* FAQ */}
        <section className="faq-section py-5">
          <Container>
            <Row>
              <h1 className="text-center mb-5">
                Frequently Asked Questions (FAQ)
              </h1>
            </Row>

            <Row>
              {faqData.map((faq, index) => (
                <Col md={6} key={index} className="mb-4">
                  <div
                    className={`faq-card ${
                      openIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-question">
                      <span>{faq.question}</span>
                      <span className="faq-icon">
                        {openIndex === index ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
